import React from 'react';
import { connect } from 'react-redux';

import Table from '../../table';

import { filterUpdateSort } from '../../../../actions/shared/index/filter';
import { isSortedColumn, sortDirection } from '../../../../selectors';

const IndexTableHeaderCell = props => (
  <Table.HeaderCell
    {...props}
    onClick={() =>
      (props.clickable && props.toggleSort(props.name, props.sortType)) || null
    }
  />
);

const mapStateToProps = () => {
  const isSorted = isSortedColumn();
  const getSortDirection = sortDirection();
  return (state, { name }) => ({
    sort: isSorted(state, name) ? getSortDirection(state, name) : undefined,
  });
};

const mapDispatchToProps = dispatch => ({
  toggleSort: (columnName, sortType) => {
    dispatch(filterUpdateSort(columnName, sortType));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(IndexTableHeaderCell);
